export default __webpack_public_path__ + "static/media/Mask Group 14.b14251b5.svg";